import {
  createStyles,
  Tooltip as MUToolTip,
  withStyles,
} from '@material-ui/core'
import { TooltipProps } from '@material-ui/core/Tooltip'
import React from 'react'
import { theme } from '../../theme'

const styles = createStyles({
  arrow: {
    color: theme.colors.palette.white,
  },
  placementBottom: {
    margin: '8px 0',
  },
  placementLeft: {
    margin: '0 8px',
  },
  placementRight: {
    margin: '0 8px',
  },
  placementTop: {
    margin: '8px 0',
  },
  tooltip: {
    backgroundColor: '#fff',
    boxShadow: '0px 0px 4px rgba(0,0,0,0.25)',
    color: 'black',
    fontSize: '11px',
    position: 'relative',
  },
  tooltipBreak: {
    backgroundColor: '#fff',
    boxShadow: '0px 0px 4px rgba(0,0,0,0.25)',
    color: 'black',
    fontSize: '11px',
    position: 'relative',
    wordBreak: 'break-all',
  },
})

function Tooltip({
                   children,
                   title,
                   classes,
                   fakeRef,
                   size = 1,
                   whiteSpace = true,
                   wordBreakAll = true,
                   boundaryElement,
                   ...rest
                 }: ITooltipProps) {
  const modifiers = {
    preventOverflow: {
      boundariesElement: boundaryElement,
    },
  }

  return (
    <MUToolTip
      title={
        <>
          <div
            style={{
              fontSize: `${11 * size}px`,
              userSelect: 'none',
              whiteSpace: 'pre-line',
              wordBreak: whiteSpace ? 'keep-all' : 'break-word',
            }}
          >
            {title}
          </div>
        </>
      }
      classes={{
        arrow: classes.arrow,
        tooltip: wordBreakAll ? classes.tooltipBreak : classes.tooltip,
        tooltipPlacementBottom: classes.placementBottom,
        tooltipPlacementLeft: classes.placementLeft,
        tooltipPlacementRight: classes.placementRight,
        tooltipPlacementTop: classes.placementTop,
      }}
      TransitionProps={{
        timeout: {
          appear: 500,
          enter: 300,
          exit: 0,
        },
      }}
      PopperProps={{
        anchorEl: fakeRef,
        modifiers: modifiers,
      }}
      {...rest}
    >
      {children}
    </MUToolTip>
  )
}

export default withStyles(styles)(Tooltip)
export type TooltipPlacement =
  | 'bottom'
  | 'left'
  | 'right'
  | 'top'
  | 'bottom-end'
  | 'bottom-start'
  | 'left-end'
  | 'left-start'
  | 'right-end'
  | 'right-start'
  | 'top-end'
  | 'top-start'

export interface ITooltipProps extends TooltipProps {
  title: string | JSX.Element | React.ReactNode
  isRoom?: boolean
  classes?: {
    arrow: string
    arrowPopper: string
    placementBottom: string
    placementLeft: string
    placementRight: string
    placementTop: string
    popper: string
    tooltip: string
    tooltipBreak: string
  }
  withArrow?: boolean
  fakeRef?: () => any
  size?: number
  whiteSpace?: boolean
  placement?: TooltipPlacement
  disablePropagation?: boolean
  color?: string
  disableHoverListener?: boolean
  wordBreakAll?: boolean
  overCursor?: boolean
  boundaryElement?: HTMLElement
}
